import "./style.css"
import { SOCIAL_LINKS } from "../../data/social-links.js"

<div class="section-container">
  <h3>Contact Me</h3>
  <div class="contact-layout">
    <div class="contact-form-col">
      <form id="form" action="https://formspree.io/f/mdopeerp" method="POST">
        <div class="form-group">
          <label class="form-label" for="_replyto">Your email</label>
          <input
            type="email"
            id="_replyto"
            name="_replyto"
            placeholder="you@example.com"
            aria-label="Your email address"
          />
        </div>
        <div class="form-group">
          <label class="form-label" for="message">Your message</label>
          <textarea
            id="message"
            name="message"
            placeholder="Type your message here…"
            aria-label="Your message"
          />
        </div>
        <button id="submit" type="submit" aria-label="Send message">
          Send Message
        </button>
      </form>
    </div>

    <div class="contact-social-col">
      <p class="contact-reach-out">
        Don't hesitate to reach out — I'm happy to help however I can!
        You can also email me directly at
        <a href="mailto:rhamm1027@gmail.com">rhamm1027@gmail.com</a>.
      </p>
      <div class="social-links">
        <for|link| of=SOCIAL_LINKS>
          <a
            href=link.href
            rel="noreferrer"
            target="_blank"
            class="social-link"
            aria-label=`Visit my ${link.label} profile`
          >
            <span>${link.label}</span>
          </a>
        </for>
      </div>
    </div>
  </div>
</div>
